import AuthContentWrapper from "./components/AuthContentWrapper";
import { C2Text, C3Text, T1Text } from "../../common/components/text/CustomText";
import { Column, Row, SizedBox } from "../../common/components/CommonBaseComponents";
import CustomInput from "../../common/components/input/CustomInput";
import { useState } from "react";
import FullWidthButton from "../../common/components/button/FullWidthButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import CustomTooltip from "../../common/components/button/CustomTooltip";
import ValidUtil from "../../common/utils/ValidUtil";
import AuthService from "../../service/AuthService";
import CustomPopup from "../../common/components/popup/CustomPopup";
import { Theme } from "../../common/Theme";

function ConfirmResetPasswordPage() {
    const navigate = useNavigate();
    const service = new AuthService();
    const [searchParams] = useSearchParams();
    const authKeyNum = searchParams.get("authKeyNum");

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    // api 에러 팝업
    const [isPopupOpened, setIsPopupOpened] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");

    // 성공 팝업
    const [isSuccessPopupOpened, setIsSuccessPopupOpened] = useState(false);

    async function handleResetPassword() {
        if (
            !(
                password.length > 0 &&
                confirmPassword.length > 0 &&
                password === confirmPassword &&
                ValidUtil.validatePassword(password)
            )
        ) {
            return;
        }

        try {
            await service.resetPassword({ password: password, authKeyNum: authKeyNum });
            setIsSuccessPopupOpened(true);
        } catch (error) {
            setPopupMessage(error.message);
            setIsPopupOpened(true);
        }
    }

    return (
        <AuthContentWrapper contentPadding={"62px 60px"}>
            <Column justifyContent={"center"}>
                <T1Text letterSpacing={"-0.56px"} fontWeight={"500"}>
                    Enter a new Password
                </T1Text>
                <SizedBox height={"10px"} />
                <C2Text fontColor={Theme.color.gray500}>Create a new password for your account</C2Text>
            </Column>
            <SizedBox height={"44px"} />
            <Row overflowX={"visible"}>
                <C2Text fontWeight={"500"}>Password</C2Text>
                <SizedBox width={"4px"} />
                <CustomTooltip>
                    <C3Text fontColor={Theme.color.gray500}>
                        Enter a valid password. Password must be 8 characters or more and have at least two of the
                        following: alphabets, numbers and symbols.
                    </C3Text>
                </CustomTooltip>
            </Row>
            <SizedBox height={"6px"} />
            <CustomInput
                placeholder={"Enter Password"}
                type={"password"}
                padding={"14px 16px"}
                inputValue={password}
                setInputValue={setPassword}
                isValid={ValidUtil.validatePassword(password) || !(password.length > 0)}
            />
            <SizedBox height={"15px"} />
            <C2Text fontWeight={"500"}>Confirm Password</C2Text>
            <SizedBox height={"6px"} />
            <CustomInput
                placeholder={"Enter Password"}
                type={"password"}
                padding={"14px 16px"}
                inputValue={confirmPassword}
                setInputValue={setConfirmPassword}
                isValid={password === confirmPassword || !(confirmPassword.length > 0)}
            />
            <SizedBox height={"32px"} />
            <FullWidthButton
                onClick={handleResetPassword}
                text={"OK"}
                isActive={password.length > 0 && confirmPassword.length > 0 && password === confirmPassword}
            />
            <CustomPopup isOpen={isPopupOpened} onConfirm={() => setIsPopupOpened(false)} message={popupMessage} />
            <CustomPopup
                isOpen={isSuccessPopupOpened}
                onConfirm={() => navigate("/auth/login")}
                message={"Password changed successfully."}
            />
        </AuthContentWrapper>
    );
}

export default ConfirmResetPasswordPage;
